module.exports = __webpack_public_path__ + "static/media/  (76).9ed1e2f4.jpg";